<template>
  <div class="ticket-list-body-b">
    <bcc-table
      :columns="columns"
      :data="ticketData"
      emptyText="当前没有授权消息"
      :show-loading="ticketDataLoading"
      @sort-change='handleSort'
      align="center">
      <template slot="level" slot-scope="scope">
        <span class="ellipsis-1">{{scope.row.level === 20 ? '管理员' : '开发者'}}</span>
      </template>
      <template slot="state" slot-scope="scope">
        <span v-html="renderState(scope.row.state)"></span>
      </template>
      <template slot="ctime" slot-scope="scope">
        <span>{{renderTime(scope.row.ctime)}}</span>
      </template>
      <template slot="mtime" slot-scope="scope">
        <span>{{renderTime(scope.row.mtime) || '-'}}</span>
      </template>
      <template slot="operate" slot-scope="scope">
        <div v-if='[0, 1].includes(scope.row.state)' class="operate-view" @click="handleView(scope.row)">查看</div>
        <div v-else>-</div>
      </template>
    </bcc-table>

    <div class="ticket-list-pagination" v-if='ticketData.length'>
      <bcc-pagination
        :current="pn"
        :page-size="ps"
        :total="total"
        @on-change="changeticketPage"
        show-total
      ></bcc-pagination>
    </div>
    <InviteeDialog @refreshData='renderList("init")' ref='dialog' />
  </div>
</template>

<script>
import {login} from "@/utils/login"
import InviteeDialog from './inviteeDialog'

export default {
  name: "ticket",
  components: {
    InviteeDialog
  },
  data() {
    return {
      pageOptions: [{
        label: 10,
        value: 10
      }],
      columns: [
        {
          title: '发起人',
          key: 'mname_from',
        },
        {
          title: '授权发起时间',
          key: 'ctime',
        },
        {
          title: '权限',
          key: 'level',
          sortable: true
        },
        {
          title: '授权状态',
          key: 'state',
        },
        {
          title: '操作',
          key: 'operate',
        }
      ],
      ticketData: [],
      ticketDataLoading: false,
      pn: 1,
      ps: 10,
      total: 0,
      topStatus: null,
      curTab: ''
    }
  },
  created() {
    if (this.$store.state.userInfo) {
      this.renderList()
    } else {
      this.$router.push({
        name: 'home'
      })
      login()
    }
  },
  methods: {
    handleSort (key, order) {
      console.log('我是这里的排序啊啊', key, order)
    },
    handleView (row) {
      this.$refs.dialog.show = true
      this.$refs.dialog.data = {...row, app_names: row.app_names.split(',')}
    },
    changePageSize() {
      this.renderList()
    },
    async renderList(type) {
      if (type === 'init') {
        this.pn = 1
      }
      this.ticketDataLoading = true
      await this.$api.auth.messageList({
        pn: this.pn,
        ps: this.ps,
      }).then(data => {
        let tableData = data.list || []
        this.ticketData = tableData
        this.total = data.page.total
        this.ticketDataLoading = false
      }).catch(e => {
        console.error(e)
        this.$message({
          content: e.message,
          type: 'exception',
          offset: 60,
          duration: 1500
        })
        this.ticketDataLoading = false
      })
    },
    changeticketPage(pn) {
      if (pn <= 0) return
      this.pn = pn
      this.renderList()
    },
    renderState(state) {
      // 状态(0待接收;1已接受;2已拒绝;3已撤销)
      switch (state) {
        case 0:
          return '<span style="color: #FAAB4B;">待接受</span>'
        case 1:
          return '<span>已接受</span>'
        case 2:
          return '<span style="color: #FA5A57">已拒绝</span>'
        case 3:
          return '<span style="color: gray;">已撤销</span>'
        default:
          return '<span style="color: #FA5A57;">已解绑</span>'
      }
    },
    renderTime(time) {
      if(time === '') return ''
      return window.moment.unix(time).format('YYYY-MM-DD HH:mm')
    },
  }
}
</script>

<style scoped lang="scss">
.company-ticket-list {
  min-width: 960px;
  width: 100%;
  max-width: 1168px;
  margin: auto;
}

.ticket-list-head {
  padding: 16px 0 16px 26px;
}

.ticket-list-body {
  border: 1px solid #E7E7E7;
  min-height: 100px;

  .ticket-list-body-h {
    display: flex;
    align-items: center;
    padding: 0 26px;
    border-bottom: 1px solid #E7E7E7;
    height: 64px;
    justify-content: space-between;

    h3 {
      font-size: 24px;
      color: #212121;
    }
  }

  .ticket-list-body-b {
    padding: 24px;

    .ticket-list-pagination {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 30px;

      .txt {
        font-size: 14px;
        margin-right: 20px;
      }

      .ps-select {
        margin-right: 40px;
      }
    }
  }
}

.goto-ticket-detail {
  color: #1389BF;
}

.goto-ticket-detail-disabled {
  cursor: not-allowed !important;
  user-select: none;
  opacity: .5;
}

.reply-img {
  width: 25px;
  height: 25px;
  cursor: pointer;
}
.tabs {
  margin-left: 25px;
}
.operate-view {
  color: #1389BF;
  cursor: pointer;
}
</style>
